export default "__VITE_ASSET__GhWSZGnf_m7y3CdHtTYSFw__"